import React from "react";

export const PrivacyPolicy = (props: any) => {
  return (
    <div className="privacy-policy">
      <h1>SITE UNDER DEVELOPMENT</h1>
      <h1>Privacy Policy for Sungka Live</h1>
      <p>
        PRIVACY POLICY This privacy policy applies between you, the User of this
        Website, and MR JEOFF MORRIS, the owner and provider of this Website. MR
        JEOFF MORRIS takes the privacy of your information very seriously. This
        privacy policy applies to our use of any and all Data collected by us or
        provided by you in relation to your use of the Website.{" "}
      </p>
      <p>
        This privacy policy should be read alongside, and in addition to, our
        Terms and Conditions, which can be found
        at: http://sungka.live/terms-and-conditions.{" "}
      </p>
      <b>
        Please read this privacy policy carefully. Definitions and
        interpretation
      </b>{" "}
      <ul>
        <li>In this privacy policy, the following definitions are used:</li>
      </ul>
      <table className="privacy-policy-table">
        <tr>
          <td>
            Data collectively all information that you submit to MR JEOFF
            MORRIS via the Website. This definition incorporates, where
            applicable, the definitions provided in the Data Protection Laws;
          </td>
        </tr>
        <tr>
          <td>
            Cookies a small text file placed on your computer by this Website
            when you visit certain parts of the Website and/or when you use
            certain features of the Website. Details of the cookies used by this
            Website are set out in the clause below (Cookies);
          </td>
        </tr>
        <tr>
          <td>
            Data Protection Laws any applicable law relating to the processing
            of personal Data, including but not limited to the GDPR, and any
            national implementing and supplementary laws, regulations and
            secondary legislation;
          </td>
        </tr>
        <tr>
          <td>GDPR the UK General Data Protection Regulation;</td>
        </tr>
        <tr>
          <td>
            MR JEOFF MORRIS,    we  or us MR JEOFF MORRIS of 12, Eyeletter
            House, Greenwood Road, Northamptonshire, NN5 5EG; 
          </td>
        </tr>
        <tr>
          <td>
            UK and EU Cookie Law the Privacy and Electronic Communications (EC
            Directive) Regulations 2003 as amended by the Privacy and Electronic
            Communications (EC Directive) (Amendment) Regulations 2011 & the
            Privacy and Electronic Communications (EC Directive) (Amendment)
            Regulations 2018;
          </td>
        </tr>
        <tr>
          <td>
            User or you any third party that accesses the Website and is not
            either (i) employed by MR JEOFF MORRIS and acting in the course of
            their employment or (ii) engaged as a consultant or otherwise
            providing services to MR JEOFF MORRIS and accessing the Website in
            connection with the provision of such services; and{" "}
          </td>
        </tr>
        <tr>
          <td>
            Website the website that you are currently
            using, https://sungka.live, and any sub-domains of this site unless
            expressly excluded by their own terms and conditions.
          </td>
        </tr>
      </table>
      <br></br>
      <ul>
        <li>
          In this privacy policy, unless the context requires a different
          interpretation:{" "}
          <ul>
            <li> the singular includes the plural and vice versa; </li>
            <li>
              {" "}
              references to sub-clauses, clauses, schedules or appendices are to
              sub-clauses, clauses, schedules or appendices of this privacy
              policy;{" "}
            </li>
            <li>
              a reference to a person includes firms, companies, government
              entities, trusts and partnerships; d. "including" is understood to
              mean{" "}
            </li>
            <li>"including without limitation"; e. </li>
            <li>
              reference to any statutory provision includes any modification or
              amendment of it;{" "}
            </li>
            <li>
              the headings and sub-headings do not form part of this privacy
              policy.  
            </li>
          </ul>
        </li>
      </ul>
      <b>Scope of this privacy policy.</b>
      <ul>
        <li>
          This privacy policy applies only to the actions of MR JEOFF MORRIS and
          Users with respect to this Website. It does not extend to any websites
          that can be accessed from this Website including, but not limited to,
          any links we may provide to social media websites.
          <li>
            {" "}
            For purposes of the applicable Data Protection Laws, MR JEOFF
            MORRIS is the "data controller". This means that MR JEOFF
            MORRIS determines the purposes for which, and the manner in which,
            your Data is processed.
          </li>
        </li>
      </ul>{" "}
      <b>Data collected</b>
      <ul>
        <li>
          {" "}
          We may collect the following Data, which includes personal Data, from
          you
          <ul>
            <li>name;</li>
            <li>date of birth;</li>
            <li>gender;</li>
            <li>
              contact Information such as email addresses and telephone numbers;
            </li>
            <li>your social network information agreed upon;</li>
          </ul>
        </li>{" "}
        in each case, in accordance with this privacy policy.
      </ul>{" "}
      <b>How we collect Data</b>{" "}
      <ul>
        <li>
          We collect Data in the following ways:
          <ul>
            <li> data is given to us by you; and</li>
            <li>data is collected automatically.</li>
          </ul>
        </li>
      </ul>{" "}
      <b>Data that is given to us by you</b>{" "}
      <ul>
        <li>
          MR JEOFF MORRIS will collect your Data in a number of ways, for
          example:
          <ul>
            <li>
              when you contact us through the Website, by telephone, post,
              e-mail or through any other means;
            </li>
            <li>
              when you register with us and set up an account to receive our
              products/services;
            </li>
            <li>
              when you make payments to us, through this Website or otherwise;
            </li>
            <li>
              when you elect to receive marketing communications from us; in
              each case, in accordance with this privacy policy.
            </li>
          </ul>
        </li>
      </ul>
      <b>Data that is collected automatically</b>
      <ul>
        <li>
          To the extent that you access the Website, we will collect your Data
          automatically, for example:
          <ul>
            <li>
              we automatically collect some information about your visit to the
              Website. This information helps us to make improvements to Website
              content and navigation, and includes your IP address, the date,
              times and frequency with which you access the Website and the way
              you use and interact with its content.
            </li>
            <li>
              we will collect your Data automatically via cookies, in line with
              the cookie settings on your browser. For more information about
              cookies, and how we use them on the Website, see the section
              below, headed "Cookies".
            </li>
          </ul>
        </li>
      </ul>
      <b>Our use of Data</b>
      <ul>
        <li>
          Any or all of the above Data may be required by us from time to time
          in order to provide you with the best possible service and experience
          when using our Website. Specifically, Data may be used by us for the
          following reasons:
          <ul>
            <li>improvement of our products / services;</li>
            <li>
              transmission by email of marketing materials that may be of
              interest to you;
            </li>
            <li>
              contact for market research purposes which may be done using
              email, telephone, fax or mail. Such information may be used to
              customise or update the Website;
            </li>
          </ul>
          in each case, in accordance with this privacy policy.
        </li>
        <li>
          We may use your Data for the above purposes if we deem it necessary to
          do so for our legitimate interests. If you are not satisfied with
          this, you have the right to object in certain circumstances (see the
          section headed "Your rights" below).
        </li>
        <li>
          For the delivery of direct marketing to you via e-mail, we'll need
          your consent, whether via an opt-in or soft-opt-in:
          <ul>
            <li>
              soft opt-in consent is a specific type of consent which applies
              when you have previously engaged with us (for example, you contact
              us to ask us for more details about a particular product/service,
              and we are marketing similar products/services). Under "soft
              opt-in" consent, we will take your consent as given unless you
              opt-out.
            </li>
            <li>
              for other types of e-marketing, we are required to obtain your
              explicit consent; that is, you need to take positive and
              affirmative action when consenting by, for example, checking a
              tick box that we'll provide.
            </li>
            <li>
              if you are not satisfied with our approach to marketing, you have
              the right to withdraw consent at any time. To find out how to
              withdraw your consent, see the section headed "Your rights" below.
            </li>
          </ul>
        </li>
        <li>
          Technical and organisational measures include measures to deal with
          any suspected data breach. If you suspect any misuse or loss or
          unauthorised access to your Data, please let us know immediately by
          contacting us via this e-mail address: py.sungka@gmail.com.
        </li>
        <li>
          If you want detailed information from Get Safe Online on how to
          protect your information and your computers and devices against fraud,
          identity theft, viruses and many other online problems, please visit
          www.getsafeonline.org. Get Safe Online is supported by HM Government
          and leading businesses.
        </li>
      </ul>
      <b>Keeping Data secure</b>
      <ul>
        <li>
          We will use technical and organisational measures to safeguard your
          Data, for example:
          <ul>
            <li>
              access to your account is controlled by a password and a user name
              that is unique to you.
            </li>
            <li>we store your Data on secure servers.</li>
          </ul>
        </li>
        <li>
          Technical and organisational measures include measures to deal with
          any suspected data breach. If you suspect any misuse or loss or
          unauthorised access to your Data, please let us know immediately by
          contacting us via this e-mail address: py.sungka@gmail.com.
        </li>
        <li>
          If you want detailed information from Get Safe Online on how to
          protect your information and your computers and devices against fraud,
          identity theft, viruses and many other online problems, please visit
          www.getsafeonline.org. Get Safe Online is supported by HM Government
          and leading businesses.
        </li>
      </ul>
      <b>Data retention</b>
      <ul>
        <li>
          Unless a longer retention period is required or permitted by law, we
          will only hold your Data on our systems for the period necessary to
          fulfil the purposes outlined in this privacy policy or until you
          request that the Data be deleted.
        </li>
        <li>
          Even if we delete your Data, it may persist on backup or archival
          media for legal, tax or regulatory purposes.
        </li>
      </ul>
      <b>Your rights</b>
      <ul>
        <li>
          You have the following rights in relation to your Data:
          <ul>
            <li>
              <b>Right to access</b> - the right to request (i) copies of the
              information we hold about you at any time, or (ii) that we modify,
              update or delete such information. If we provide you with access
              to the information we hold about you, we will not charge you for
              this, unless your request is "manifestly unfounded or excessive."
              Where we are legally permitted to do so, we may refuse your
              request. If we refuse your request, we will tell you the reasons
              why.
            </li>
            <li>
              <b>Right to correct</b> - the right to have your Data rectified if
              it is inaccurate or incomplete.
            </li>
            <li>
              <b>Right to erase </b>the right to request that we delete or
              remove your Data from our systems.
            </li>
            <li>
              <b>Right to restrict our use of your Data </b>Data - the right to
              "block" us from using your Data or limit the way in which we can
              use it.
            </li>
            <li>
              <b>Right to data portability </b>portability - the right to
              request that we move, copy or transfer your Data.
            </li>
            <li>
              <b>Right to object </b> - the right to object to our use of your
              Data including where we use it for our legitimate interests.
            </li>
          </ul>
        </li>
        <li>
          To make enquiries, exercise any of your rights set out above, or
          withdraw your consent to the processing of your Data (where consent is
          our legal basis for processing your Data), please contact us via this
          e-mail address: py.sungka@gmail.com.
        </li>
        <li>
          If you are not satisfied with the way a complaint you make in relation
          to your Data is handled by us, you may be able to refer your complaint
          to the relevant data protection authority. For the UK, this is the
          Information Commissioner's Office (ICO). The ICO's contact details can
          be found on their website at https://ico.org.uk/.
        </li>
        <li>
          It is important that the Data we hold about you is accurate and
          current. Please keep us informed if your Data changes during the
          period for which we hold it.
        </li>
      </ul>
      <b>Links to other websites</b>
      <ul>
        <li>
          This Website may, from time to time, provide links to other websites.
          We have no control over such websites and are not responsible for the
          content of these websites. This privacy policy does not extend to your
          use of such websites. You are advised to read the privacy policy or
          statement of other websites prior to using them.
        </li>
      </ul>
      <b>Changes of business ownership and control</b>
      <ul>
        <li>
          MR JEOFF MORRIS may, from time to time, expand or reduce our business
          and this may involve the sale and/or the transfer of control of all or
          part of MR JEOFF MORRIS. Data provided by Users will, where it is
          relevant to any part of our business so transferred, be transferred
          along with that part and the new owner or newly controlling party
          will, under the terms of this privacy policy, be permitted to use the
          Data for the purposes for which it was originally supplied to us.
        </li>
        <li>
          We may also disclose Data to a prospective purchaser of our business
          or any part of it.
        </li>
        <li>
          In the above instances, we will take steps with the aim of ensuring
          your privacy is protected.
        </li>
      </ul>
      <b>Cookies</b>
      <ul>
        <li>
          This Website may place and access certain Cookies on your
          computer.   MR JEOFF MORRIS uses Cookies to improve your experience of
          using the Website and to improve our range of products.    MR JEOFF
          MORRIS has carefully chosen these Cookies and has taken steps to
          ensure that your privacy is protected and respected at all times.
        </li>
        <li>
          All Cookies used by this Website are used in accordance with current
          UK and EU Cookie Law.
        </li>
        <li>
          Before the Website places Cookies on your computer, you will be
          presented with a message bar requesting your consent to set those
          Cookies. By giving your consent to the placing of Cookies, you are
          enabling MR JEOFF MORRIS to provide a better experience and service to
          you. You may, if you wish, deny consent to the placing of Cookies;
          however certain features of the Website may not function fully or as
          intended.
        </li>
        <li>This Website may place the following Cookies:</li>{" "}
        <table className="privacy-policy-table">
          <tr>
            <td>Type of Cookie</td>
            <td>Purpose</td>
          </tr>
          <tr>
            <td>Strictly necessary cookies</td>
            <td>
              These are cookies that are required for the operation of our
              website. They include, for example, cookies that enable you to log
              into secure areas of our website, use a shopping cart or make use
              of e-billing services.
            </td>
          </tr>
          <tr>
            <td>Functionality cookies</td>
            <td>
              These are used to recognise you when you return to our website.
              This enables us to personalise our content for you, greet you by
              name and remember your preferences (for example, your choice of
              language or region). By using the Website, you agree to our
              placement of functionality cookie.
            </td>
          </tr>
        </table>
        <li>
          You can find a list of Cookies that we use in the Cookies Schedule.
        </li>
        <li>
          You can choose to enable or disable Cookies in your internet browser.
          By default, most internet browsers accept Cookies but this can be
          changed. For further details, please see the help menu in your
          internet browser. You can switch off  Cookies at any time, however,
          you may lose any information that enables you to access the Website
          more quickly and efficiently.
        </li>
        <li>
          You can choose to delete Cookies at any time; however, you may lose
          any information that enables you to access the Website more quickly
          and efficiently including, but not limited to, personalisation
          settings.
        </li>
        <li>
          It is recommended that you ensure that your internet browser is
          up-to-date and that you consult the help and guidance provided by the
          developer of your internet browser if you are unsure about adjusting
          your privacy settings.
        </li>
        <li>
          For more information generally on cookies, including how to disable
          them, please refer to aboutcookies.org. You will also find details on
          how to delete cookies from your computer.
        </li>
      </ul>
      <b>General</b>
      <ul>
        <li>
          You may not transfer any of your rights under this privacy policy to
          any other person. We may transfer our rights under this privacy policy
          where we reasonably believe your rights will not be affected.
        </li>
        <li>
          If any court or competent authority finds that any provision of this
          privacy policy (or part of any provision) is invalid, illegal or
          unenforceable, that provision or part-provision will, to the extent
          required, be deemed to be deleted, and the validity and enforceability
          of the other provisions of this privacy policy will not be affected.
        </li>
        <li>
          Unless otherwise agreed, no delay, act or omission by a party in
          exercising any right or remedy will be deemed a waiver of that, or any
          other, right or remedy.
        </li>
        <li>
          This Agreement will be governed by and interpreted according to the
          law of England and Wales. All disputes arising under the Agreement
          will be subject to the exclusive jurisdiction of the English and Welsh
          courts.
        </li>
      </ul>
      <b>Changes to this privacy policy</b>
      <ul>
        <li>
          MR JEOFF MORRIS reserves the right to change this privacy policy as we
          may deem necessary from time to time or as may be required by law. Any
          changes will be immediately posted on the Website and you are deemed
          to have accepted the terms of the privacy policy on your first use of
          the Website following the alterations.   You may contact MR JEOFF
          MORRIS by email at py.sungka@gmail.com.
        </li>
      </ul>
      <b>Cookies</b>
      <ul>
        <li>
          Below is a list of the cookies that we use. We have tried to ensure
          this is complete and up to date, but if you think that we have missed
          a cookie or there is any discrepancy, please let us know.
        </li>
      </ul>
      <b>
        <small>Strictly necessary</small>
      </b>
      <p>We use the following strictly necessary cookies:</p> 
      <table className="privacy-policy-table">
        <tr>
          <td>Description</td>
          <td>Purpose</td>
        </tr>
        <tr>
          <td>Strictly necessary cookies</td>
          <td>Google Firebase: Cookie for collection of data about users</td>
        </tr>
        <tr>
          <td>Functionality cookies</td>
          <td>Mobile device cookie for collection of data about App Users</td>
        </tr>
      </table>
      <p>
        <b>
          <small>Functionality</small>
        </b>
      </p>
      <p>We use the following strictly necessary cookies:</p> 
      <table className="privacy-policy-table">
        <tr>
          <td>Description</td>
          <td>Purpose</td>
        </tr>
        <tr>
          <td>Strictly necessary cookies</td>
          <td>Google Firebase: Cookie for collection of data about users</td>
        </tr>
        <tr>
          <td>Functionality cookies</td>
          <td>Mobile device cookie for collection of data about App Users</td>
        </tr>
      </table>
    </div>
  );
};
